export default __webpack_public_path__ + "static/yatch-aaba186b9c1c909a86dc797e2598af58.webp";